import PageHero from "./PageHero";

const NewsHero = () => {
  return (
    <PageHero
      title={<>Latest News &amp; <span className="text-gradient-brand">Insights</span></>}
      description="Stay updated on AI innovations, industry trends, and company updates"
      blobPosition="right"
    />
  );
};

export default NewsHero;
